import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { FAQ_ITEMS } from '../mock/mock';

export default function FAQ() {
  return (
    <section id="faqs" className="py-24 lg:py-32 bg-white">
      <div className="mx-auto max-w-4xl px-6 lg:px-10">
        <div className="text-center mb-12">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-neutral-900 tracking-tight">
            Frequently asked questions
          </h2>
          <p className="mt-4 text-lg text-neutral-600">
            Everything you need to know about Transformerus.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-neutral-50 rounded-2xl border border-neutral-200 px-5 data-[state=open]:bg-white data-[state=open]:shadow-sm"
            >
              <AccordionTrigger className="text-left text-base font-semibold text-neutral-900 hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-600 text-[15px] leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
